import { render } from "./App.vue?vue&type=template&id=66a461ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=66a461ec&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_bb4469d58753dffd1fec5b0ad5bf78e8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__